import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import {
  PaneHeaderIconButton,
  PaneMenu,
} from '@folio/stripes/components';
import { ICONS } from '../../../constants';

const NavigateBackPaneFirstMenu = ({ onClickHandler }) => {
  const intl = useIntl();

  return (
    <PaneMenu>
      <PaneHeaderIconButton
        data-test-pane-header-dismiss-button
        aria-label={intl.formatMessage({ id: 'ui-task-list.form.btn.cancel' })}
        icon={ICONS.TIMES}
        onClick={onClickHandler}
      />
    </PaneMenu>
  );
};

NavigateBackPaneFirstMenu.propTypes = {
  onClickHandler: PropTypes.func.isRequired
};

export default NavigateBackPaneFirstMenu;
